import React, { memo } from 'react';
import { Button } from 'components/Button/Button';
import { DropDownMenu } from 'components/DropDownMenu/DropDownMenu';
import { SquareFourIcon } from 'components/Icons';
import { Switcher } from 'components/Switcher/Switcher';
import { Text } from 'components/Typography';
import { PatientTableColName, VisibleColumnsConfigType } from 'containers/AllPatients/components/PatientTable/PatientTableTypes';
import style from './CustomizeTableMenu.scss';

type Props = {
  toggleColumn: (key: PatientTableColName) => void;
  columnsConfig: VisibleColumnsConfigType;
};

export const CustomizeTableMenu: React.FC<Props> = memo(({ toggleColumn, columnsConfig }) => {
  return (
    <DropDownMenu
      customMenuElement={(onMenuClick) => (
        <Button variant="outlined" onClick={onMenuClick} startIcon={<SquareFourIcon width={18} height={18} />}>
          Customize table
        </Button>
      )}
      multiActions
      menuItems={Object.entries(columnsConfig).map(([key, { title, visible }]) => ({
        customMenuItem: () => (
          <div className={style.menuOption}>
            <Text variant="md">{title}</Text>
            <Switcher checked={visible} onChange={() => toggleColumn(key as PatientTableColName)} />
          </div>
        )
      }))}
    />
  );
});
